const PURCHASE_DEFAULTS: Record<string, string> = {
  subscriptionTier: 'Annual',
  gaiaProductSku: 'annual',
  price: '99.99',
  currency: 'USD',
  planName: 'Annual',
  trialPeriod: 'false',
  paymentProvider: 'zuora',
}

const BEHAVIORAL_DEFAULTS: Record<string, string> = {
  subscriptionTier: 'Annual',
  planName: 'Annual',
  gaiaProductSku: 'annual',
}

export const SUBSCRIPTION_EVENT_DEFAULT_FIELD_VALUES: Record<string, Record<string, string>> = {
  subscription_signup: { ...PURCHASE_DEFAULTS, trialPeriod: 'true' },
  subscription_renewed: PURCHASE_DEFAULTS,
  plan_changed: {
    ...PURCHASE_DEFAULTS,
    effectiveDate: new Date().toISOString().slice(0, 10),
    isUpgrade: 'false',
    isDowngrade: 'false',
  },
  refund_completed: PURCHASE_DEFAULTS,
  subscription_canceled: {
    ...BEHAVIORAL_DEFAULTS,
    cancelReason: 'admin-qa',
    winback: 'false',
  },
  subscription_paused: {
    ...BEHAVIORAL_DEFAULTS,
    holdStartDate: new Date().toISOString().slice(0, 10),
    holdEndDate: '',
    pauseDate: new Date().toISOString().slice(0, 10),
  },
  subscription_resumed: {
    ...BEHAVIORAL_DEFAULTS,
    resumeDate: new Date().toISOString().slice(0, 10),
  },
  refund_requested: BEHAVIORAL_DEFAULTS,
  subscription_comped: {
    ...BEHAVIORAL_DEFAULTS,
    compedDays: '30',
  },
  payment_failed: {
    ...BEHAVIORAL_DEFAULTS,
    failureReason: 'Card declined',
    price: '99.99',
    currency: 'USD',
  },
}

export function getDefaultSubscriptionFieldValues (templateId: string): Record<string, string> {
  return { ...(SUBSCRIPTION_EVENT_DEFAULT_FIELD_VALUES[templateId] || BEHAVIORAL_DEFAULTS) }
}
